/**
 * THIS IS AN EXTENSION FOR ENTITY ADD (Add.vue), A HELPER FOR SPECIFIC SCENARIOS
 * if you have a use case with an exception for regular entity behaviour (like uploading 
 * files after posting an entity) you can add method,function calls to the events methods:
 *      validForSpecificScenarios
 *      beforeSaveForSpecificScenarios
 *      afterSaveForSpecificScenarios
 * these are called in Add.Vue when saving, all additional calls inside the events should
 * have an if/switch or whatever condition the check if that call code should be executed
 * (meet the exception case) for example the call uploadFilesForOrderOrShipment() inside 
 * afterSaveForSpecificScenarios checks that the entity is pointing (through the 'alias' property)
 * to Order or Shipment if not then returns, just like that.
 * this mixin uses the instance in vuex using the accesor from the Add.vue EntityMixin
 * from the Add.vue EntityMixin from '@/mixins'
 */
import axios from 'axios'
export default {
  methods: {
    /**
     * validation event prior to save, must return bool
     * @param {*} entity 
     * @param {*} instance 
     */
    async validForSpecificScenarios(entity, instance) {
      console.log(`[validForSpecificScenarios]`);
      return true;
    },
    async beforeSaveForSpecificScenarios(entity, instance) {
      console.log(`[beforeSaveForSpecificScenarios]`);
    },
    async afterSaveForSpecificScenarios(entity, instance, response) {
      console.log(`[afterSaveForSpecificScenarios]`);
      this.uploadFilesForOrderOrShipment(response);
    },
    async errorsForSpecificScenarios(errors = []) {
      console.log(`[errorsForSpecificScenarios]`);
    },
    
    async uploadFilesForOrderOrShipment(response) {
      if ((this.entity.alias == 'Order' || this.entity.alias == 'Shipment') && this.formData != null) {
        console.log(`[uploadFilesForOrderOrShipment] uploading files`);
        await axios.post(`file/media/${response.data.id}`, this.formData)
      }
    }
  }
}